import { IS_APP_BUILD } from './buildTarget';

// WHY a dedicated constant and NOT API_BASE: in dev app-mode API_BASE points at
// localhost, where the static legal HTML pages do not exist. The legal notices
// live ONLY on the production website (served by Cloudflare Pages), so the app
// must always link there, regardless of which backend it talks to.
const PROD_WEB_ORIGIN = 'https://quizessa.com';

// Single source of truth for the legal page URLs in the React app.
// EN pages live at /privacy and /terms; ES pages at /es/privacidad and /es/terminos.
// These are static pages served by Cloudflare (see frontend/public/_redirects),
// not SPA routes, so consumers must render plain <a> tags, not <Link>.
//
// APP build (F4.2c): those static pages are pruned from the Capacitor bundle
// (scripts/postbuild-app.js), so relative paths would 404 inside the WebView.
// The links become absolute production URLs instead — with target="_blank"
// (LegalAcceptance) they open outside the app shell. WEB build: IS_APP_BUILD is
// false → the relative paths below are exactly what shipped before.
export function getLegalLinks(language) {
  const isES = typeof language === 'string' && language.startsWith('es');
  const links = isES
    ? { privacy: '/es/privacidad', terms: '/es/terminos' }
    : { privacy: '/privacy', terms: '/terms' };
  if (IS_APP_BUILD) {
    return { privacy: PROD_WEB_ORIGIN + links.privacy, terms: PROD_WEB_ORIGIN + links.terms };
  }
  return links;
}
